import Carousel from "../components/carousel/Carousel";
import WorldMap from "../components/sections/WorldMap";
import HomeArticles from "../components/articles/home/homeArticles";
import { useContext, useEffect, useState } from "react";
import axiosInstance from "../configurations/axiosInstance/AxiosInstance";
import Mission from "../components/mission/mission";
import Themes from "../components/themes/themes";
import Testimonials from "../components/testimonials/Testimonials";
import Partenaires from "../components/partenaires/partenaires";
import { LoadingContext } from "../composants/loadingContext";
import Loader from "../composants/loader/Loader";
import Valeur from "../components/valeurs/valeur";
import "../styles/landingPage.css";


export default function LandingPage() {
  const { loading, setLoading } = useContext(LoadingContext)
  const [articles, setArticles] = useState([]);
  const [missions, setMissions] = useState([]);
  const [valeurs, setValeurs] = useState([]);
  const [slides, setSlides] = useState([]);
  const [themes, setThemes] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const defaultSlide = {
    id: 0,
    cover: '/images/cover.jpg',
    image: null,
    title: 'YouthFP',
    subtitle: 'Young People'
  };
  const slidesInit = [defaultSlide];

  const fetchArticle = async () => {
    try {
      const response = await axiosInstance().get('public/api/article/active/home');
      const data = response.data.filter(article => article.status === true);
      if (data) {
        setArticles(data);
      } else {
        setArticles([]);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des articles:', error);
      setArticles([]);
    }
  };

  const fetchSlide = async () => {
    try {
      const response = await axiosInstance().get('public/api/sliders/by/front/WEB_SITE');
      const data = response.data;
      slidesInit.length = 0; // Clear default slides
      slidesInit.push(defaultSlide); // Re-add default slide

      if (data) {
        for (const element of data) {
          slidesInit.push({
            id: element.id,
            cover: element.photo,
            image: element.photo,
            title: element.title,
            subtitle: element.message
          });
        }
        setSlides(slidesInit);
      } else {
        setSlides(slidesInit);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des slides:', error);
      setSlides(slidesInit);
    }
  };

  const fetchTheme = async () => {
    try {
      const response = await axiosInstance().get('public/api/theme');
      const data = response.data;
      if (data) {
        setThemes(data);
      } else {
        setThemes([]);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des thèmes:', error);
      setThemes([]);
    }
  };

  const fetchTestimonials = async () => {
    try {
      const response = await axiosInstance().get('public/api/temoignage/active');
      const data = response.data;
      if (data) {
        setTestimonials(data);
      } else {
        setTestimonials([]);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des témoignages:', error);
      setTestimonials([]);
    }
  };

  const fetchMissions = async () => {
    try {
      const response = await axiosInstance().get('public/api/missions');
      const data = response.data;
      if (data) {
        setMissions(data);
      } else {
        setMissions([]);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des missions:', error);
      setMissions([]);
    }
  };

  const fetchValeurs = async () => {
    try {
      const response = await axiosInstance().get('public/api/valeur/find-active');
      const data = response.data;
      if (data) {
        setValeurs(data);
      } else {
        setValeurs([]);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des valeurs:', error);
      setValeurs([]);
    }
  };

  const init = async () => {
    setLoading(true);
    await fetchArticle();
    await fetchSlide();
    await fetchMissions();
    await fetchValeurs();
    await fetchTheme();
    await fetchTestimonials();
    setLoading(false);
  }
  useEffect(
    () => {
      document.title = 'YouthFP|Accueil';
      init();
    }, []
  );

  return (
    <>
      {loading && <Loader />}
      <div className="animated fadeIn" style={{ paddingTop: 27 }}>
        {/* Section Hero - Carousel */}
        <section className="relative">
          <Carousel slides={slides} />
        </section>

        {/* Section À Propos / Introduction */}
        <section className="bg-gradient-to-b from-white to-gray-50 py-16 px-4">
          <div className="max-w-7xl mx-auto text-center">
            <h2 style={{ fontFamily: 'Mrs Saint Delafield' }} className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 animate__animated animate__fadeInUp">
              Bienvenue chez YouthFP
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Une organisation dédiée à la promotion de la santé sexuelle et reproductive des jeunes.
              Nous œuvrons pour un avenir où chaque jeune a accès à l'information, aux services et au soutien nécessaires.
            </p>
          </div>
        </section>

        {
          missions.length !== 0 && <section className="py-16 px-4 bg-white">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 style={{ fontFamily: 'Mrs Saint Delafield' }} className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                  Les Objectifs
                </h2>
                <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
              </div>
              <Mission missions={missions} />
            </div>
          </section>
        }

        {
          valeurs.length !== 0 && <section className="py-16 px-4 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 style={{ fontFamily: 'Mrs Saint Delafield' }} className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                  Les Valeurs
                </h2>
                <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full"></div>
                <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
                  Les principes qui guident notre action au quotidien
                </p>
              </div>
              <Valeur valeurs={valeurs} />
            </div>
          </section>
        }

        {
          themes.length !== 0 && <section className="py-16 px-4 bg-white">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 style={{ fontFamily: 'Mrs Saint Delafield' }} className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                  Thèmes Traités
                </h2>
                <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-teal-500 mx-auto rounded-full"></div>
                <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
                  Les domaines d'intervention de notre organisation
                </p>
              </div>
              <Themes themes={themes} />
            </div>
          </section>
        }

        {
          articles.length !== 0 && <section className="py-16 px-4 bg-gray-50">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 style={{ fontFamily: 'Mrs Saint Delafield' }} className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                  Actualités & Articles
                </h2>
                <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-red-500 mx-auto rounded-full"></div>
                <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
                  Restez informés de nos dernières actions et publications
                </p>
              </div>
              <HomeArticles articles={articles} />
            </div>
          </section>
        }

        {
          testimonials.length !== 0 && <section className="py-16 px-4 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 style={{ fontFamily: 'Mrs Saint Delafield' }} className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                  Témoignages
                </h2>
                <div className="w-24 h-1 bg-gradient-to-r from-pink-500 to-purple-500 mx-auto rounded-full"></div>
                <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
                  Ce que disent les jeunes qui ont bénéficié de nos services
                </p>
              </div>
              <Testimonials testimonials={testimonials} />
            </div>
          </section>
        }

        {/* Section Carte Mondiale */}
        <section className="py-16 px-4 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 style={{ fontFamily: 'Mrs Saint Delafield' }} className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Notre Portée Mondiale
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-green-500 mx-auto rounded-full"></div>
              <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
                Découvrez notre impact à travers le monde
              </p>
            </div>
            <WorldMap />
          </div>
        </section>

        {/* Section Partenaires */}
        {/* <section className="py-16 px-4 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Nos Partenaires
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-yellow-500 to-orange-500 mx-auto rounded-full"></div>
              <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
                Ensemble pour un impact plus grand
              </p>
            </div>
            <Partenaires />
          </div>
        </section> */}

        {/* Section Call-to-Action Final */}
        <section className="py-20 px-4 bg-gradient-to-r from-purple-600 via-pink-600 to-red-600 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-5xl font-bold mb-6">
              Rejoignez Notre Mouvement
            </h2>
            <p className="text-lg md:text-xl mb-8 opacity-90">
              Ensemble, construisons un avenir où chaque jeune a le pouvoir de prendre des décisions éclairées sur sa santé sexuelle et reproductive.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="/register"
                className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 shadow-lg"
              >
                S'inscrire Maintenant
              </a>
              <a
                href="/about"
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-purple-600 transform hover:scale-105 transition-all duration-300"
              >
                En Savoir Plus
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
